import { bootstrapApplication } from '@angular/platform-browser';
import { rewriteLegacyHashUrl } from 'utilities';
import { appConfig } from './app/app.config';
import { App } from './app/app';

rewriteLegacyHashUrl();

bootstrapApplication(App, appConfig).catch(err => console.error(err));
